export default "__VITE_ASSET__CX7e721L__"